import $ from 'jquery';
import lodash from 'lodash';
import { basketUpdate } from '../queries';
import { updatePrices } from '../utilities';

const basketUpdateDebounced = lodash.debounce(async (productId, quantity) => {
    let isMobile = false;
    if (window.innerWidth <= 768) {
        isMobile = true
    }

    const response = await basketUpdate(productId, quantity, isMobile);
    const wasOpened = $('.header-basket').hasClass('header-basket--opened');
    if (window.innerWidth <= 768) {
        $('.header-basket--mobile').replaceWith(response.component);
    }else{
        $('.header-basket').replaceWith(response.component);
    }

    if (wasOpened) {
        $('.header-basket').addClass('header-basket--opened');
    }
    setTimeout(() => {
        if (!$('.header-basket').hasClass('header-basket--hovered')) {
            $('.header-basket').removeClass('header-basket--opened');
        }
    }, 2000);
    updatePrices();
}, 300);

$(document).on('set', '.ui-product-quantity', function (e, value) {
    $(this).attr('data-quantity', value).find('.ui-product-quantity__value').text(value);
});

$(document).on('change', '.ui-product-quantity', function (e, value) {
    $(this).trigger('set', value);

    const productId = +$(this).attr('data-product-id');
    basketUpdateDebounced(productId, value);
});

$(document).on('click', '.ui-product-quantity__sub', function (e) {
    e.preventDefault();
    const $component = $(this).parents('.ui-product-quantity');

    if ($component.attr('data-amount') === undefined) {
        return;
    }

    const value = +$component.attr('data-quantity') - 1;

    $component.trigger('change', value);
});

$(document).on('click', '.ui-product-quantity__add', function (e) {
    e.preventDefault();
    const $component = $(this).parents('.ui-product-quantity');

    if ($component.attr('data-amount') === undefined) {
        return;
    }

    const amount = +$component.attr('data-amount');
    const value = +$component.attr('data-quantity') + 1;

    if (value > amount) {
        return;
    }

    $component.trigger('change', value);
});
